import React from 'react';
import Crypto from 'crypto';

const generateSha256 = (text) => {
    const result = Crypto.createHash('sha256').update(text).digest('hex');

    return result;
}

export default generateSha256;